<template>
<div class="bk-color">

<v-row class="icoev-header-row fixNotchMarginTop fixNotchPaddingBottom" style="height: 88px; max-height: 88px;">
			<v-col cols="12" class="icoev-header-title">
				<h4>
					<v-icon color="primary" style="top: -2px;">mdi-view-list</v-icon>
					Trámites colegiales
				</h4>
			</v-col>

  <v-tabs
		v-model="tab"
		center-active
		fixed-tabs
		class="icoev-tabs">
    <v-tab key="0">Trámites</v-tab>
    <v-tab key="1">Clínicas</v-tab>

    <!-- Trámites -->
    <v-tab-item  style="padding-bottom: 10px;">
        <v-card
			outlined
			class="mx-auto mt-3"
			max-width="100%"
		>
          <h4 class="primary--text pa-2">Realizar trámite</h4>
          <v-card-text class="pa-0">
            <v-list>
                <div>
                    <v-list-item @click="openUrl(0)">
                        <v-list-item-content>
                            <v-list-item-title style="white-space: normal; font-size: 14px; font-weight: 700;">Certificado de colegiación</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon color="primary">mdi-open-in-new</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider/>
                    <v-list-item @click="openUrl(1)">
                        <v-list-item-content>
                            <v-list-item-title style="white-space: normal; font-size: 14px; font-weight: 700;">Área privada de colegiado (facturas y diplomas)</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon color="primary">mdi-open-in-new</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider/>
                    <v-list-item @click="openUrl(2)">
                        <v-list-item-content>
                            <v-list-item-title style="white-space: normal; font-size: 14px; font-weight: 700;">Solicitud de recetas en soporte papel</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon color="primary">mdi-open-in-new</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider/>
                    <v-list-item @click="openUrl(3)">
                        <v-list-item-content>
                            <v-list-item-title style="white-space: normal; font-size: 14px; font-weight: 700;">Solicitud curso director radiodiagnóstico</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon color="primary">mdi-open-in-new</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider/>
                    <v-list-item @click="openUrl(4)">
                        <v-list-item-content>
                            <v-list-item-title style="white-space: normal; font-size: 14px; font-weight: 700;">Solicitud carnet colegial</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon color="primary">mdi-open-in-new</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider/>
                    <v-divider/>
                    <v-list-item @click="openUrl(5)">
                        <v-list-item-content>
                            <v-list-item-title style="white-space: normal; font-size: 14px; font-weight: 700;">Alta para profesional disponible en agosto</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon color="primary">mdi-open-in-new</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider/>
                    <v-list-item @click="openUrl(6)">
                        <v-list-item-content>
                            <v-list-item-title style="white-space: normal; font-size: 14px; font-weight: 700;">Alta para profesional disponible en festivos</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon color="primary">mdi-open-in-new</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider/>
                    <v-list-item @click="openUrl(7)">
                        <v-list-item-content>
                            <v-list-item-title style="white-space: normal; font-size: 14px; font-weight: 700;">Otros trámites con descarga de formulario PDF</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon color="primary">mdi-open-in-new</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </div>
            </v-list>
          </v-card-text>
        </v-card>
    </v-tab-item>

    <!-- Clínicas -->
    <v-tab-item :style="{ bottom: anyClinicEdited ? '56px' : '56px' }" style="overflow-y: auto; overflow-x: hidden; top: 90px; position: fixed; width: 96%;" class="fixNotchMarginTop fixNotchPaddingBottom">

		<v-alert v-if="!isLoading && items.length == 0" type="error" style="margin: 30px 20px 20px 20px;">
			No se han encontrado datos
		</v-alert>

		<!--<v-card v-if="!isLoading && items.length > 0"
			outlined
			class="mx-auto mt-3"
			max-width="100%"
			:style="{ marginBottom: anyClinicEdited ? '108px' : '-8px' }"
		>-->
        <v-card v-if="!isLoading && items.length > 0"
			outlined
			class="mx-auto mt-3"
			max-width="100%"
		>

			<v-card-text class="pa-0">
				<v-list style="padding: 0;">
					<div v-for="item in items" :key="item.id">
						<v-list-item three-line :style="{ minHeight: item.id < 7 ? '88px' : '44px' }">
							<v-list-item-content>
								<ClinicItem :data="item" @open-clinic-dialog="openClinicDialog($event)"/>
							</v-list-item-content>
						</v-list-item>
						<v-divider v-if="item.id != items[items.length-1].id"/>
					</div>
				</v-list>
			</v-card-text>
		</v-card>

        <div v-if="anyClinicEdited" style="position: relative; bottom: -10px; width: 96%; min-height: 118px;"></div>

		<v-alert
			color="#ff5252"
			dense
			class="fixNotchMarginTop fixNotchPaddingBottom"
			style="position: fixed; bottom: 50px; font-size: 14px; padding-top: 0; padding-bottom: 0; margin: 4px auto; width: 96%;"
			v-if="tab == 1 && anyClinicEdited">
            <v-row>
                <v-col cols="12" style="padding: 12px 12px 0 12px;">
					<span style="color: white;">
						Pulsa en enviar cuando hayas finalizado todos los cambios de clínicas para que podamos procesar tu solicitud.
					</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="d-flex justify-end pa-0 pb-1">
					<v-btn text color="white" @click="confirmSend()">
						Enviar
					</v-btn>
					<v-btn text color="white" @click="confirmCancel()">
						Cancelar
					</v-btn>
                </v-col>
            </v-row>
		</v-alert>
	</v-tab-item>

	</v-tabs>
    </v-row>

		<ConfirmDialog ref='dlgConfirmSend'
			:title="'CONFIRMAR ENVÍO'"
			:message="'¿Desea enviar los cambios que ha realizado?'"
			:titleOk="'Confirmar'"
			:titleCancel="'Cancelar'"
			@confirmed="sendRequestMail()"/>
		<ConfirmDialog ref='dlgConfirmCancel'
			:title="'CONFIRMAR CANCELACIÓN'"
			:message="'¿Desea cancelar los cambios que ha realizado?'"
			:titleOk="'Aceptar'"
			:titleCancel="'Cancelar'"
			@confirmed="clearEditedClinics()"/>
    </div>
</template>

<script>
import api from '../../../api/icoev';
import BaseModule from "../../common/BaseModule";
import ClinicItem from "../../common/ClinicItem";
import discovery from '../../../discovery';
import ConfirmDialog from "../../common/ConfirmDialog";
import cordova from "../../../api/cordova";

export default {
  name: 'TramitesMain',
	mixins: [ BaseModule ],
	components: {
		ClinicItem, ConfirmDialog
	},
	data () {
		return {
			isLoading: false,
			tab: 0,
			links: [
				'https://www.icoev.es/servicios-para-colegiados/rido_tramites-colegiales/solicitud_tramite/?tramite=Certificado%20de%20colegiaci%C3%B3n',
				'https://www.icoev.es/privado/',
				'https://www.icoev.es/servicios-para-colegiados/rido_tramites-colegiales/recetas_en_papel/',
				'https://www.icoev.es/servicios-para-colegiados/rido_tramites-colegiales/solicitud_tramite/?tramite=Solicitud%20curso%20director%20radio',
				'https://www.icoev.es/servicios-para-colegiados/rido_tramites-colegiales/solicitud_tramite/?tramite=Solicitud%20carnet%20colegial',
				'https://www.icoev.es/servicios-para-colegiados/rido_tramites-colegiales/dentistasagosto/',
				'https://www.icoev.es/servicios-para-colegiados/rido_tramites-colegiales/clinicas_disponibles_festivos_alta/',
				'https://www.icoev.es/servicios-para-colegiados/rido_tramites-colegiales/soli_tramites-colegiales/',
			],
			page: 0,
			items: [],
			originalItems: [],
			selector: null,
			showMoreContent: false,
			isDirty: true,
			lastUpdate: null,
		}
	},
  mounted() {
		this.$nextTick(() => {
			window.$vue.$on('ne_awake', this.processAwake);
    });
  },
	methods: {
		processAwake: function(seconds) {
			this.$log.debug("TramitesMain - processAwake: " + seconds + " secs");
			if (seconds > this.MAX_UPDATE_DELAY_IN_SECONDS) {
				//this.$log.debug("TramitesMain - processAwake: paused > 10 secs -> dirty = true");
				this.isDirty = true;
			}
		},
		listarItems: function() {
			if (!this.$store.state.icoev.user) {
				return;
			}

			this.$log.debug("TramitesMain - listarItems()");

			this.isLoading = true;

			this.items = [];
			this.originalItems = [];

			this.$store.commit('icoev/clearEditedClinics');

			api.getClinics(this.$store.state.icoev.user.numcol,
				res => {
					this.isLoading = false;

					if (!res.rsOK) {
						this.$emit('alert-event', { text: res.message, color: 'error', timeout: 3000 });
						return;
					}

					this.lastUpdate = new Date();

					if (res.entities.length == 0) {
						return;
					}

					this.items = res.entities;
					this.originalItems = [...this.items];

					this.showMoreContent = false;

					if (!this.selector) {
						this.selector = '#clinic' + this.items[0].id;
					}

					if (this.selector) {
						this.$nextTick(() => {
							var anchor = this.$el.querySelector(this.selector);
							if (anchor) {
								anchor.scrollIntoView();
							}
						});
					}
				},
				err => {
					this.isLoading = false;
					this.$log.error(err);
					this.$emit('alert-event', { text: 'Error al actualizar las clínicas', color: 'error', timeout: 3000 });
				}
			);
		},
		addMoreContent: function() {
			this.page++;
			this.selector = '#clinic' + this.items[this.items.length - 1].id;
			this.showMoreContent = false;

			this.listarItems();
		},
		openUrl(index) {
			if (this.$store.state.icoev.device.platform == 'browser') {
				window.open(this.getRedirectUrl(this.links[index]));
				return;
			}

			if (this.$store.state.icoev.device.platform == 'android') {
				cordova.openUrl(encodeURI(this.getRedirectUrl(this.links[index])));
			} else {
				this.$emit('open-external-content', 'Trámites colegiales', this.getRedirectUrl(this.links[index]));
			}
		},
		/*openUrl(index) {
			this.$emit('open-external-content', 'Trámites colegiales', this.getRedirectUrl(this.links[index]));
		},*/
		getRedirectUrl(target) {
			return discovery.icoev_service_url+"users/redirect/"+this.$store.state.icoev.redirectToken+"?t="+target;
		},
		openClinicDialog: function(clinic) {
			this.$emit('open-clinic-dialog', clinic, this.clinicEdited);
		},
		clinicEdited: function(clinic, editedClinic) {
			if (editedClinic.deleted) {
				var index = this.items.findIndex(x => x.id == clinic.id);
				if (index != -1) {
					this.items.splice(index, 1, this.originalItems[index]);
					editedClinic.clinic = this.originalItems[index];
				}
			} else  {
				// eslint-disable-next-line no-redeclare
				var index = this.items.findIndex(x => x.id == clinic.id);
				if (index != -1) {
					this.items.splice(index, 1, editedClinic.clinic);
				}
			}

			this.$store.commit('icoev/addEditedClinic', editedClinic);
		},
		confirmSend: function() {
			this.$refs.dlgConfirmSend.confirm();
		},
		confirmCancel: function() {
			this.$refs.dlgConfirmCancel.confirm();
		},
		sendRequestMail: function() {
			this.$store.state.icoev.editedClinics.sort(function(a, b) {
				if (a.clinic.id < b.clinic.id) {
					return -1;
				}
				if (a.clinic.id > b.clinic.id) {
					return 1;
				}
				return 0;
			});

			var data = {
				user: this.$store.state.icoev.user,
				editedClinics: this.$store.state.icoev.editedClinics
			};

			api.editClinics(data,
				(res) => {
					if (!res) {
						this.$emit('alert-event', { text: 'Error al enviar la solicitud', color: 'error', timeout: 3000 });
						return;
					}

					this.listarItems();
					this.$emit('alert-event', { text: 'La solicitud se envió con éxito', color: 'success', timeout: 3000 });
				},
				(err) => {
					this.$log.error(err);
					this.$emit('alert-event', { text: 'Error al enviar la solicitud', color: 'error', timeout: 3000 });
				});
		},
		clearEditedClinics: function() {
			this.listarItems();
		},
		doAlert(message) {
			this.$emit('alert-event', message);
		},
		reset() {
			this.page = 0;
			this.items = [];
			this.originalItems = [];
			this.selector = null;
			this.showMoreContent = false;
			this.isDirty = true;
		}
	},
	computed: {
		userChanged() {
			return this.$store.state.icoev.user;
		},
		anyClinicEdited() {
			return this.$store.state.icoev.editedClinics.length > 0;
		}
	},
	watch: {
		userChanged() {
			this.reset();
		},
		// eslint-disable-next-line no-unused-vars
		/*$route (to, from) {
			if (to.name !== 'tramites') {
				return;
			}

			//this.$log.debug("TramitesMain - to.params.redirect: " + to.params.redirect);
			if (to.params.redirect) {
				to.params.redirect = false;
				//this.$log.debug("TramitesMain - clearCache()");
				api.clearClinicsCache();
				//this.$log.debug("TramitesMain - reset()");
				this.tab = 1;
				this.reset();
			}
			//this.$log.debug("TramitesMain - isDirty: " + this.isDirty);
			if (this.isDirty) {
				this.isDirty = false;
				this.$nextTick(() => {
					this.listarItems();
        });
				//this.$log.debug("TramitesMain - isDirty: " + this.isDirty);
			}
		},*/
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			if (to.name !== 'tramites') {
				return;
			}

			if (vm.needsUpdate(vm.lastUpdate)) {
				vm.reset();
			}

			//vm.$log.debug("TramitesMain - to.params.redirect: " + to.params.redirect);
			if (to.params.redirect) {
				//vm.$log.debug("TramitesMain - clearCache()");
				api.clearClinicsCache();
				//vm.$log.debug("TramitesMain - reset()");
				vm.tab = 1;
				vm.reset();
			}
			//vm.$log.debug("TramitesMain - isDirty: " + vm.isDirty);
			if (vm.isDirty) {
				vm.isDirty = false;
				vm.$nextTick(() => {
					vm.listarItems();
        });
				//vm.$log.debug("TramitesMain - isDirty: " + vm.isDirty);
			}
		})
	},
}
</script>

<style scoped>
  .media-object {
    width: 128px;
    padding: 10px;
  }

  .media {
    border-top: 1px solid lightgrey;
    padding-top: 20px;
    list-style-type: none;
  }
</style>